/**
 * 에러 코드를 문자열 메시지로 변환하는 공통 모듈
 */

// 에러 코드 상수
export const ERROR_CODES = {
  UNKNOWNERROR: 1000100,
  SYSTEMFAILURE: 1000101,
  UNAUTHORIZATIONERROR: 1000401,
  INVALIDPARAM: 1000402,
  INVALIDSTATUS: 1000403,
  INVALIDTOKEN: 1000404,
  EXPIREDTOKEN: 1000405,
  INVALIDATEDTOKEN: 1000406,
  NOTSUPPORT: 1000407,
  NOTFOUND: 1000408,
  INVALIDUSER: 1000409,
  EXCEEDEDFAILCNT: 1000410,
  EMAILSENDFAIL: 1000411,
  EXISTALREADY: 1000412,
  EXPIRED: 1000413,
  OVERLIMIT: 1000414,
  JSONPROCERROR: 1000500,
  EXTERNALAPIERROR: 1000501,
};

// 에러 코드별 메시지 매핑
const ERROR_MESSAGES = {
  [ERROR_CODES.UNKNOWNERROR]: `에러가 발생하였습니다(에러코드: ${ERROR_CODES.UNKNOWNERROR})`,
  [ERROR_CODES.SYSTEMFAILURE]: `시스템에러 (에러코드: ${ERROR_CODES.SYSTEMFAILURE})`,
  [ERROR_CODES.UNAUTHORIZATIONERROR]: "이용권한이 없습니다.",
  [ERROR_CODES.INVALIDPARAM]: `입력값에 오류가 있습니다. (에러코드: ${ERROR_CODES.INVALIDPARAM})`,
  [ERROR_CODES.INVALIDSTATUS]: `에러가 발생하였습니다(에러코드: ${ERROR_CODES.INVALIDSTATUS})`,
  [ERROR_CODES.INVALIDTOKEN]: `불법적인 접근이 시도되었습니다. (에러코드: ${ERROR_CODES.INVALIDTOKEN})`,
  [ERROR_CODES.EXPIREDTOKEN]: `로그인이 만료되었습니다. 다시 로그인해 주세요. (에러코드: ${ERROR_CODES.EXPIREDTOKEN})`,
  [ERROR_CODES.INVALIDATEDTOKEN]: `로그인을 종료하였습니다. (에러코드: ${ERROR_CODES.INVALIDATEDTOKEN})`,
  [ERROR_CODES.NOTSUPPORT]: "지원하지 않는 기능입니다.",
  [ERROR_CODES.NOTFOUND]: `요청하신 정보가 없습니다. (에러코드: ${ERROR_CODES.NOTFOUND})`,
  [ERROR_CODES.INVALIDUSER]: "허용되지 않는 사용자입니다.",
  [ERROR_CODES.EXCEEDEDFAILCNT]: "허용 회수를 초과하였습니다.",
  [ERROR_CODES.EMAILSENDFAIL]: "이메일 발송에 실패하였습니다.",
  [ERROR_CODES.EXISTALREADY]: `이미 존재합니다. (에러코드: ${ERROR_CODES.EXISTALREADY})`,
  [ERROR_CODES.EXPIRED]: `만료되었습니다. (에러코드: ${ERROR_CODES.EXPIRED})`,
  [ERROR_CODES.OVERLIMIT]: `제한 개수를 초과하였습니다. (에러코드: ${ERROR_CODES.OVERLIMIT})`,
  [ERROR_CODES.JSONPROCERROR]: `메세지 형식이 잘못되었습니다. (에러코드: ${ERROR_CODES.JSONPROCERROR})`,
  [ERROR_CODES.EXTERNALAPIERROR]: `시스템에 오류가 있습니다. (에러코드: ${ERROR_CODES.EXTERNALAPIERROR})`,
};

/**
 * 에러 코드를 문자열 메시지로 변환
 * @param {number} errorCode - 에러 코드
 * @returns {string} 에러 메시지
 */
export const getErrorMessage = (errorCode) => {
  if (!errorCode) {
    return "알 수 없는 오류가 발생했습니다.";
  }
  
  // 정의된 에러 코드인 경우 해당 메시지 반환
  if (ERROR_MESSAGES[errorCode]) {
    return ERROR_MESSAGES[errorCode];
  }
  
  // 정의되지 않은 에러 코드인 경우 기본 메시지 반환
  return `에러가 발생하였습니다(에러코드: ${errorCode})`;
};

/**
 * API 응답에서 에러 코드를 확인하고 메시지를 반환
 * @param {Object} response - API 응답 객체
 * @returns {string|null} 에러 메시지 (성공인 경우 null)
 */
export const checkApiResponse = (response) => {
  if (!response) {
    return "응답이 없습니다.";
  }
  
  const errorCode = response.errorCode;
  
  // errorCode가 0이면 성공
  if (errorCode === 0) {
    return null;
  }
  
  // 에러인 경우 메시지 반환
  if(response.response &&  response.response.length > 0){
    return getErrorMessage(errorCode) + " : " + response.response;
  }
  return getErrorMessage(errorCode);
};

/**
 * API 응답을 안전하게 처리하는 헬퍼 함수
 * @param {Object} response - API 응답 객체
 * @returns {Object} { success: boolean, data: any, errorMessage: string|null }
 */
export const processApiResponse = (response) => {
  const errorMessage = checkApiResponse(response);
  
  if (errorMessage) {
    return {
      success: false,
      data: null,
      errorMessage: errorMessage
    };
  }
  
  return {
    success: true,
    //data: response.response || response.data || response,
    data:response.response,
    page:response.page,
    errorMessage: null
  };
}; 